const initStickyFilters = () => {
  const stickyFacetContainerEl = document.querySelector('[data-sticky-facets]');
  if(!stickyFacetContainerEl) return;

  const checkStickyFacetContainer = () => {
    const headerHeightVariable = window.getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    const headerHeight = parseInt(headerHeightVariable);
    const isStuck = stickyFacetContainerEl.getBoundingClientRect().top <= headerHeight;
    stickyFacetContainerEl.classList.toggle('facets-wrapper--is-stuck', isStuck);
  }

  window.addEventListener('scroll', throttle(checkStickyFacetContainer, 50));
  document.body.addEventListener('header-height-set', checkStickyFacetContainer);
}

initStickyFilters();